import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const ModalBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  backgroundColor: 'white',
  borderRadius: '1rem',
  position: 'relative',
  display: 'inline-block',
  padding: '3rem',
  height: 'auto',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    padding: '2rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
}));

export const ModalBtnClose = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: '1rem',
  top: '1rem',

  [theme.breakpoints.down('md')]: {
    right: '0.5rem',
    top: '0.7rem',
  },
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.secondary.main,
  marginTop: '1rem',
  fontWeight: 'bold',
}));

export const ModalSpan = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const ModalSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  margin: '0.5rem 0 1.7rem',
}));

export const ProductDescription = styled(Container)(({ theme }) => ({
  display: 'flex',
  margin: '3.5rem auto 5.62rem',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    width: '90%',
    margin: '2.12rem auto 3.43rem',
  },
}));

export const StyledDescription = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  alignItems: 'start',
}));

export const ButtonStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '1rem',
  margin: '2rem 0 1rem',
}));
